import {
  Box,
  Button, Icon, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { BsFillCircleFill } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { get } from '@submize/lodash';
import { useGetPublicTemplatesQuery, useGetTemplatesQuery, useLazyGetTemplateQuery } from '../../Services/templates';
import { setDesign } from './formSlice';

const SelectTemplate = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: templates, isLoading: isLoadingTemplates } = useGetTemplatesQuery();
  const { data: publicTemplates } = useGetPublicTemplatesQuery();
  const [trigger, { isLoading }] = useLazyGetTemplateQuery();
  const dispatch = useDispatch();
  const handleSelectTemplate = async (id) => {
    const template = await trigger(id);
    const design = get(template, 'data.schema.design');
    dispatch(setDesign(design));
    onClose();
  };

  return (
    <>
      <Button onClick={onOpen} size="sm" colorScheme="blue" variant="outline" mb="3">Choose template</Button>
      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="gray.600" pb="2">Select template</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="14px" color="gray.600">
            You can choose one of your templates or you can use a public template.
            <Tabs isFitted variant="enclosed" mt="4">
              <TabList>
                <Tab>My templates</Tab>
                <Tab>Public templates</Tab>
              </TabList>
              <TabPanels border="1px solid" borderTop="none" borderColor="gray.200">
                <TabPanel display="flex" flexDir="column" alignItems="start">
                  {isLoadingTemplates && (
                    <Box w="100%" display="flex" justifyContent="center">
                      <Spinner />
                    </Box>
                  )}
                  {(templates || []).map((template) => (
                    <Button
                      key={template.id}
                      size="sm"
                      variant="link"
                      colorScheme="blue"
                      my="2"
                      leftIcon={<Icon as={BsFillCircleFill} width="10px" mb="1px" />}
                      onClick={() => handleSelectTemplate(template.id)}
                      isDisabled={isLoading}
                    >
                      {template.name}
                    </Button>
                  ))}
                  {(templates || []).length === 0 && <Text>You have no custom templates</Text>}
                </TabPanel>
                <TabPanel>
                  <TabPanel display="flex" flexDir="column" alignItems="start">
                    {(publicTemplates || []).map((template) => (
                      <Button
                        key={template.id}
                        size="sm"
                        variant="link"
                        colorScheme="blue"
                        my="2"
                        leftIcon={<Icon as={BsFillCircleFill} width="10px" mb="1px" />}
                        onClick={() => handleSelectTemplate(template.id)}
                        isDisabled={isLoading}
                      >
                        {template.name}
                      </Button>
                    ))}
                  </TabPanel>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </ModalBody>

          <ModalFooter />
        </ModalContent>
      </Modal>
    </>
  );
};

export default SelectTemplate;
